import React from 'react';
import { Target, Award, RotateCcw, List, Swords, ChevronsRight, Home } from 'lucide-react';
import { LAW_CONFIG } from '../../data/laws';

export default function GameResult({ status, onRetry, onHome, onStageSelect, onToExpert, onNextStage, mode, gameModeType, selectedLaw, selectedStage, handleNextStage }) {
  
  if (status === 'game-over') {
    return (
      <div className="text-center py-20 bg-slate-800 rounded-xl shadow-lg border border-slate-700 flex flex-col items-center">
        <Target className="w-16 h-16 text-red-500 mb-6 animate-pulse" />
        <h2 className="text-3xl font-bold text-white mb-3">탈락했습니다!</h2>
        <div className="flex flex-col w-full max-w-xs space-y-3 mt-4">
            <button onClick={onRetry} className="w-full bg-red-600 hover:bg-red-500 text-white px-6 py-3 rounded-lg font-bold flex items-center justify-center transition hover:scale-105"><RotateCcw className="w-5 h-5 mr-2" /> 다시 도전하기</button>
            <button onClick={onStageSelect} className="w-full bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg font-bold flex items-center justify-center transition"><List className="w-5 h-5 mr-2" /> 단계 선택으로</button>
        </div>
      </div>
    );
  }

  if (status === 'clear') {
    const stages = LAW_CONFIG[selectedLaw]?.stages || [];
    const currentIndex = stages.findIndex(s => s.id === selectedStage);
    const nextStageData = (currentIndex !== -1 && currentIndex < stages.length - 1) ? stages[currentIndex + 1] : null;

    return (
      <div className="text-center py-12 bg-slate-800 rounded-xl shadow-lg border border-slate-700 flex flex-col items-center">
        <Award className="w-20 h-20 text-yellow-400 mb-6 animate-bounce" />
        <h2 className="text-3xl font-bold text-white mb-2">학습 완료!</h2>
        <p className="text-slate-400 mb-8">모든 문제를 훌륭하게 맞히셨습니다.</p>
        
         <div className="flex flex-col w-full max-w-sm space-y-3 px-4">
            <button onClick={onRetry} className="w-full bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg font-bold transition flex items-center justify-center border border-slate-600">
                <RotateCcw className="w-5 h-5 mr-2" /> 같은 조건으로 재도전
            </button>

            {mode === 'beginner' && (
                <button onClick={onToExpert} className="w-full bg-red-700 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-bold transition flex items-center justify-center shadow-lg border border-red-500/50 animate-pulse">
                    <Swords className="w-5 h-5 mr-2" /> 숙련자 모드로 바로 도전
                </button>
            )}

            {gameModeType === 'normal' && nextStageData && (
               <button onClick={() => handleNextStage(nextStageData.id)} className="w-full bg-indigo-600 hover:bg-indigo-500 text-white px-6 py-4 rounded-lg font-bold transition flex items-center justify-center shadow-lg transform hover:scale-105">
                    <ChevronsRight className="w-5 h-5 mr-2" /> 다음 단계 ({nextStageData.title}) 도전
               </button>
            )}

            <button onClick={onHome} className="w-full bg-slate-800 text-slate-400 hover:text-white px-6 py-3 rounded-lg font-bold transition flex items-center justify-center mt-2 border border-slate-700">
                <Home className="w-5 h-5 mr-2" /> 메인으로 돌아가기
            </button>
        </div>
      </div>
    );
  }
  return null;
}